import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import { useNavigate } from "react-router-dom"
import API from "../../api/axios"
import { FaRegEyeSlash } from "react-icons/fa6" // Import icon
import { connect } from "react-redux"
import Breadcrumb from "components/Common/Breadcrumb"
//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"

import "./patienttable.scss"
import PatientForm from "./PatientForm"

const DatatableTables = props => {
  document.title = "Data Table | Lexa - Responsive Bootstrap 5 Admin Dashboard"
  const [tableData, setTableData] = useState([])

  const navigate = useNavigate()

  const handleEditClick = patient => {
    console.log("patient id", patient)
    navigate(`/profile/${patient.id}`, { state: { patientData: patient } })
  }

  useEffect(() => {
    GetALLPatientData()
  }, [])

  async function GetALLPatientData() {
    try {
      const authToken = localStorage.getItem("authToken")
      const response = await API.get("/patients", {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      })
      setTableData(response.data)
      //dispatch patientcount to the redux
      props.setBreadcrumbItems(
        "Patient Table",
        breadcrumbItems,
        response.data.length,
      )
      console.log(response.data.length)

      // setLoading(false);
    } catch (err) {
      // setError("Error fetching patient");
      // setLoading(false);
      console.log(err)
    }
  }

  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Patient", link: "#" },
    // { title: "Data Tables", link: "#" },
  ]

  const tableDataConfig = {
    columns: [
      { label: "First Name", field: "fname", sort: "asc", width: 150 },
      { label: "Last Name", field: "lname", sort: "asc", width: 150 },
      { label: "Phone", field: "phone", sort: "asc", width: 150 },
      { label: "Email", field: "email", sort: "asc", width: 150 },
      { label: "Gender", field: "gender", sort: "asc", width: 150 },
      // ...(userRole === "doctor"
      //   ? [
      //       {
      //         label: "Speciallity",
      //         field: "speciality",
      //         sorf: "asc",
      //         width: 150,
      //       },
      //     ]
      //   : []),

      { label: "City", field: "city", sort: "asc", width: 150 },
      { label: "State", field: "state", sort: "asc", width: 100 },
      { label: "Zip Code", field: "zipCode", sort: "asc", width: 100 },
      { label: "Country", field: "country", sort: "asc", width: 120 },
      { label: "Action", field: "action", sort: "asc", width: 150 },
    ],
    rows: tableData.map(person => ({
      fname: person.fname,
      lname: person.lname,
      phone: person.phone,
      email: person.email,
      gender: person.gender,
      // ...(userRole === "doctor"
      //   ? { speciality: person.speciality || "N/A" }
      //   : {}),

      city: person.city || "N/A",
      state: person.state || "N/A",
      zipCode: person.zipCode || "N/A",
      country: person.country || "N/A",
      action: (
        <button
          className="btn btn-success"
          onClick={() => handleEditClick(person)}
        >
          <FaRegEyeSlash size={20} className="text-green-600" />
        </button>
      ),
    })),
  }

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12">
          {/* <Breadcrumb /> */}
          <Card>
            <CardBody>
              <CardTitle className="h4">Patient Datatable</CardTitle>
              <PatientForm refresh={GetALLPatientData} />
              {/* <UserProfile refreshTable={refreshTable} /> */}
              <MDBDataTable responsive bordered data={tableDataConfig} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables)
